import React from 'react'
import "./GridCard.css"
import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

function GridCard({
    heading="",
    gridCardData=null,
    btnText=null,
    btnRef=null,
    sliderCard=false
}) {

    const navigate = useNavigate()
    
  return (
    <div className='GridCard-container standard-padding-space'>
        <div className='container'>
            <div className='text-content text-center'>
                <h3 className='body-heading mb-5'>{heading}</h3>
            </div>

            {
                gridCardData &&
                sliderCard ?
                 <Swiper
                            loop={true}
                            autoplay={{
                              delay: 1800,
                              disableOnInteraction: false,
                            }}
                            modules={[Autoplay]}
                            breakpoints={{
                              
                              992: {
                                slidesPerView: 3,
                                spaceBetween: 50,
                              },
                             
                              320: {
                                slidesPerView: 1,
                                spaceBetween: 50,
                              },
                            }}
                            className='py-4 px-4'
                          >
                    {
                        gridCardData.map((ele)=>{
                            return(
                                <SwiperSlide className='h-auto'>
                                    <div className='point-card h-100 py-3 px-4 text-center'>
                                        <img loading="lazy" src={ele.icon} alt={`${ele.title} icon`} style={{maxWidth:"100px"}} className='img-fluid'/>
                                        <h5 className='sub-heading my-3'>{ele.title}</h5>

                                        <ul style={{color:"black"}} className='ps-4 text-start'>
                                            {
                                                ele.listPoint.map((point)=>{
                                                    return(
                                                        <li className='mb-2'>{point}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
                :
                <div className='row'>
                    {
                        gridCardData.map((ele)=>{
                            return(
                                <div className='col-lg-4'>
                                    <div className='point-card h-100 py-3 px-4 text-center'>
                                        <img loading="lazy" src={ele.icon} alt={`${ele.title} icon`} style={{maxWidth:"100px"}} className='img-fluid'/>
                                        <h5 className='sub-heading my-3'>{ele.title}</h5>

                                        <ul style={{color:"black"}} className='ps-4 text-start'>
                                            {
                                                ele.listPoint.map((point)=>{
                                                    return(
                                                        <li className='mb-2'>{point}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }

            {
                btnText &&
                <div className='d-flex align-items-center mt-3 pt-4'>
                    <button className='blue-btn mx-auto' onClick={()=>{navigate("/contact")}}>{btnText}</button>
                </div>
            }
        </div>
    </div>
  )
}

export default GridCard